import { Component, Prop, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';

@Component
export class AddressItem extends ThemeComponent {
    @Ref() showEditAddressButton!: HTMLElement;
    @Ref() editAddressForm!: HTMLElement;
    @Ref() cancelShowEditAddressButton!: HTMLElement;

    init() {

        // Show edit address form
        this.$listen(this.showEditAddressButton, 'click', () => {
            this.editAddressForm.classList.remove('visually-hidden');
        });

        // Cancel edit address form
        this.$listen(this.cancelShowEditAddressButton, 'click', () => {
            this.editAddressForm.classList.add('visually-hidden');
        });
    }
}
